import { of } from "rxjs";
import {
  catchError,
  filter,
  ignoreElements,
  mergeMap,
  tap,
} from "rxjs/operators";
import { isActionOf } from "typesafe-actions";

import {
  type ConfigResponse,
  getConfig,
} from "../../state/config/config.actions";

import type { AppEpic } from "../types";

export const configEpic: AppEpic = (action$, _state$, { getJSON }) => {
  return action$.pipe(
    filter(isActionOf(getConfig.request)),
    mergeMap((action) => {
      return getJSON<ConfigResponse>(action.payload.configUrl).pipe(
        mergeMap((response) => of(getConfig.success(response))),
      );
    }),
    catchError((error) => of(getConfig.failure(error))),
  );
};

export const setupLogShippingEpic: AppEpic = (
  action$,
  _state$,
  { setLogUrl },
) => {
  return action$.pipe(
    filter(isActionOf(getConfig.success)),
    tap((action) =>
      setLogUrl(action.payload.serviceConfig.logs + "/hoylu-suite.log"),
    ),
    ignoreElements(),
  );
};
